module.exports = __webpack_public_path__ + "static/media/office-cluj.56b2a672.png";